// #region imports

// --- Angular
import { Injectable } from '@angular/core';


// --- RxJs
import { of, Subscription } from 'rxjs';

// --- HS Code
import { TeamEnquiryBaseService } from './team-enquiry-base.service';
import { TeamEnquiryModel } from '../../../models/team/team-enquiry-model';
import { ApplicationError, RegistrationResult, TeamEnquiryResult } from '../../../models';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { AppService } from '../app.service';
import { TranslateService } from '@ngx-translate/core';
import { AppToastService } from '../app-toast.service';
import { environment } from '../../../../environments/environment';
import { switchMap, catchError } from 'rxjs/operators';

import { ToastModel } from '../../../models/common/toast-model';


// #endregion

@Injectable({
  providedIn: 'root'
})
export class TeamEnquiryService extends TeamEnquiryBaseService {

  private _sendSubscription: Subscription;

  constructor(
    private appService: AppService,
    private httpClient: HttpClient,
    private translate: TranslateService,
    private toastService: AppToastService) {
    super();
  }

  clearState(): void {
    this._isSending$.next(false);
    this._isSent$.next(false);
    this._enquiryError$.next(null);
    this._enquiryResult$.next(null);
  }

  sendEnquiry(model: TeamEnquiryModel): void {
    this._isSending$.next(true);
    const enquiryUrl = environment.apiConfig.baseUrl + environment.apiConfig.teamEnquiryApi;
    this.appService.setLoading(true);

    this.httpClient
      .get(environment.apiConfig.baseUrl + environment.apiConfig.antiForgeryTokenApi).pipe(
        switchMap(() => {
          return this.httpClient.post<TeamEnquiryModel>(enquiryUrl, model)
            .pipe(catchError(this.handleError.bind(this)));
        }),
        catchError(this.handleError.bind(this))
      ).subscribe((teamEnquiryModel: TeamEnquiryModel) => {
        this._isSending$.next(false);
        this._isSent$.next(!teamEnquiryModel.hasError);
        this.appService.setLoading(false);

        this._enquiryResult$.next(teamEnquiryModel);

        if (!teamEnquiryModel.hasError) {
        this.hideEnquiryForm();

        const toastModel = {
          header: this.translate.instant('teamEnquirySuccessHeader'),
          body: this.translate.instant('teamEnquirySuccessMessage'),
          class: 'bg-success text-light',
          autoHide: true,
          delay: 3500
        } as ToastModel;

        this.toastService.show(toastModel);
      }
    });
  }

  private handleError(err) {
    this.hideEnquiryForm();

    this.appService.setLoading(false);
    this._isSending$.next(false);

    let error: ApplicationError;
    if (err && err instanceof HttpErrorResponse) {
      // A client-side or network error occurred. Handle it accordingly.
      let detailedMessage = `${err.message}`;
      if (err.statusText) {
        detailedMessage += `<br/>${err.statusText}`;
      }
      error = {
        errorMessage: this.translate.instant('errorMessageRegistration'),
        errorNumber: err.status,
        detailedMessage
      } as ApplicationError;
      if (err && err.error) {
        let msg = '';
        for (const prop in err.error) {
          if (Object.prototype.hasOwnProperty.call(err.error, prop)) {
            msg += `${prop}: ${err.error[prop].join()} `;
          }
        }
        error.errorMessage = msg;
      }
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      error = {
        errorMessage: this.translate.instant('errorMessageRegistration'),
        originalError: err
      } as ApplicationError;
    }
    this.appService.setLastError(error);

    return of({ hasError: true } as TeamEnquiryModel);
  }
}
